export function isLink(element: HTMLElement | null): element is HTMLAnchorElement {
  return element ? element.nodeName === 'A' : false;
}
